<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--project-edit">
    <!-- メインコンテンツエリア -->
    <main class="l-main">
      <!-- パンくずリスト -->
      <breadcrumb :breadcrumb-data="breadcrumbData" />
      <!-- /パンくずリスト -->

      <!-- メインコンテンツ: 上段共通エリア -->
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">ブラウザプッシュタグ設定</div>
        </div>
      </div>
      <!-- /メインコンテンツ: 上段共通エリア -->

      <!-- ブラウザプッシュタグ -->
      <TagModule
        ref="scriptTagSettings"
        :title="'ブラウザプッシュタグ・モジュールファイル'"
        :access-token="projectData.accessToken"
        :script-tag="projectData.scriptTag"
        :use-serviceworker="true"
        :use-manifest="false"
        :copy-id="'browserPushTag'"
        :update-script-tag-settings="updateScriptTagSettings"
        @settings-change="onTagSettingsChange"
      />

      <!-- プレオプトイン・ブロック解除バーオプション -->
      <DialogOptionTabs
        v-show="showDialogOption"
        :copy-id="'dialogOptionTag'"
        :class-name="'p-project-edit-for-tag'"
        :service-create-date="projectData.createDate"
        :project-icon-url="projectData.iconUrl"
      />

      <!-- トラッキングタグ -->
      <TrackingTagModule
        v-if="projectData.tracking"
        :title="'トラッキングタグ'"
        :copy-id="'trackingTag'"
        :data="projectData.tracking"
        :class-name="'p-project-edit-for-tag'"
      />

      <div v-show="!isProduction">
        <a :href="'/testpage/' + projectData.accessToken" target="_blank">テストページへ</a>
      </div>
    </main>
    <FirebaseCopyPopup ref="popup" @apply-config="applyFirebaseConfig($event)" />
  </div>
</template>

<script>
import TagModule from '../organisms/TagModule.vue';
import DialogOptionTabs from '../organisms/DialogOptionTabs.vue';
import TrackingTagModule from '../organisms/TrackingTagModule.vue';
export default {
  components: { TagModule, DialogOptionTabs, TrackingTagModule },
  props: {
    breadcrumbData: Array,
    projectData: Object,
    adminEdit: Boolean,
    isProduction: Boolean
  },
  data: function () {
    return {
      tagSettings: {
        preoptin: 0,
        ios: false,
        block: false,
        reminder: false,
      },
    }
  },
  computed: {
    showDialogOption() {
      return !!this.tagSettings.preoptin || !!this.tagSettings.ios || !!this.tagSettings.block;
    },
  },
  mounted: function () {
  },
  methods: {
    onTagSettingsChange(settings) {
      this.tagSettings = settings;
    },
    showCopyPopup: function () {
      this.$refs.popup.open();
    },
    updateScriptTagSettings: function () {
      const parser = new DOMParser();
      const scriptDocument = parser.parseFromString(this.projectData.scriptTag, 'text/html');
      const scriptTag = scriptDocument.querySelector('script');
      if (this.$refs.scriptTagSettings.isPreoptinChecked !== 0) {
        scriptTag.setAttribute('data-optindialog', 'on');
      }
      if (this.$refs.scriptTagSettings.isPreoptinChecked === 2) {
        scriptTag.setAttribute('data-requiredbrowser', 'on');
      }
      if (this.$refs.scriptTagSettings.isIosChecked) {
        scriptTag.setAttribute('data-iosdialog', 'on');
      }
      if (this.$refs.scriptTagSettings.isBlockChecked) {
        scriptTag.setAttribute('data-unblockingrequest', 'on');
      }
      if (this.$refs.scriptTagSettings.isReminderChecked) {
        scriptTag.setAttribute('data-reminder', 'on');
      }

      this.$refs.scriptTagSettings.data.scriptTag =
        `<!--  <BODY></BODY>タグ内の最下位に記述をオススメします ここから-->
    ${scriptTag.outerHTML}
    <!-- ここまで -->`;
    },
  },
}
</script>
